import classNames from "classnames";
import { FC } from "react";
import styles from "./NumberError.module.css";

type NumberErrorProps = {
  number: number;
  className: string;
  color: "red" | "yellow";
  onClick?: () => void;
};

const NumberError: FC<NumberErrorProps> = ({ number, className, color, onClick }: NumberErrorProps) => (
  <div
    className={classNames(styles.number, className, {
      [styles["number-red"]]: color === "red",
      [styles["number-yellow"]]: color === "yellow",
    })}
    onClick={
      onClick
        ? (e) => {
            e.stopPropagation();
            e.preventDefault();
            onClick();
          }
        : undefined
    }
  >
    {number}
  </div>
);

export default NumberError;
